import api from '../api';

export async function getSupportAgents() {
  try {
    const response = await api.get('/suporte');
    const { data } = response;

    if (!Array.isArray(data)) {
      console.warn('Resposta inesperada do backend:', data);
      return [];
    }

    return data;
  } catch (error) {
    console.error('Erro ao buscar agentes de suporte no serviço:', error);
    return [];
  }
}
